import React from 'react'
import styles from './styles.module.css'
import ProgressiveCustomImage from '../../../../Utils/ProgressiveCustomImage'
import HighlightedText from '../../../../Utils/HighlightedText'

function UDFP20Footer({ mainImageCs, mainTitleHl, mainTextHl,
                        section1Icon, section1TitleHl, section1TextHl,
                        section2Icon, section2TitleHl, section2TextHl,
                        section3Icon, section3TitleHl, section3TextHl
                      }) {
  return (
    <>
      <div className={styles.titleSection}>
        <div className={styles.mainImage}><ProgressiveCustomImage {...mainImageCs}/></div>
        <HighlightedText {...mainTitleHl}/>
        <div className={styles.mainText}><HighlightedText {...mainTextHl}/></div>
      </div>
      <div className={styles.subtitleSection}>
        { renderSubsection(section1Icon, section1TitleHl, section1TextHl)}
        { renderSubsection(section2Icon, section2TitleHl, section2TextHl)}
        { renderSubsection(section3Icon, section3TitleHl, section3TextHl)}
      </div>
    </>
  )
}

const renderSubsection = (sectionIcon, sectionTitle, sectionText) => {
  return (<div className={styles.subsection}>
    <div className={styles.icon}>
      <ProgressiveCustomImage {...sectionIcon}/>
    </div>
    <div className={styles.subsectionTitle}><HighlightedText {...sectionTitle}/></div>
    <div className={styles.subsectionText}><HighlightedText {...sectionText}/></div>
  </div>)
}

export default UDFP20Footer
